/**
 * @generated SignedSource<<2451aca4f2c7b1e0ee536c8db1b562f3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HeroCarouselRequestMore_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_user">;
  readonly " $fragmentType": "HeroCarouselRequestMore_user";
};
export type HeroCarouselRequestMore_user$key = {
  readonly " $data"?: HeroCarouselRequestMore_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselRequestMore_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeroCarouselRequestMore_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "3a25d2525fcc82a08a0a48ac9bc11679";

export default node;
